<template>
  <div class="d-flex align-items-center mt-2 mb-2">
    <DiamondTag :tag-text=this.category></DiamondTag>
    <div class="list-text" style="margin-left: 10px">{{this.text}}</div>
  </div>
</template>

<script>

import DiamondTag from "@/components/DiamondTag";

export default {
name: "DiamondList",
  components:{
    DiamondTag
  },
  props:{
    category: {
      type: String,
      default: "null"
    },
    text:{
      type: String,
      default: "Some text"
    }
  }
}
</script>

<style scoped>

.list-text{
  font-size: 18px;
}

</style>